import * as act from '@/store/folders.actions';
import { foldersService } from '@/services';

const state = { folders: [] };

const actions = {
  async [act.ACT_LOADFOLDERS]({ commit }) {
    await foldersService
      .Get()
      .then(result => {
        commit(act.MUT_FOLDERS, { data: result.data });
      })
      .catch(_error => {});
  }
};

const mutations = {
  [act.MUT_FOLDERS](state: any, { data }): void {
    state.folders = data;
  }
};

const getters = {
  [act.GET_FOLDERS]: state => {
    return state.folders;
  }
};

export const folders = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
